// extracted by mini-css-extract-plugin
export var errorsContainer = "_vb-1";
export var link = "_vb-0";